import type { ReactNode } from "react";
import { Link } from "react-router";
import { PRODUCT_NAME } from "../lib/config";

/** Ink masthead (story, or the fee calculator) beside a ruled sheet holding the form. */
export function AuthLayout({ masthead, children }: { masthead: ReactNode; children: ReactNode }) {
  return (
    <div className="auth">
      <section className="masthead on-ink" aria-label={`About ${PRODUCT_NAME}`}>
        <Link to="/" className="wordmark">
          {PRODUCT_NAME}
        </Link>
        {masthead}
        <p className="label">ATS · Invoicing · Contracts — for independent recruiters</p>
      </section>
      <main className="sheet">
        <div className="sheet-inner">{children}</div>
      </main>
    </div>
  );
}
